export const API_CHOOSE_PLAN = "/sales/subscription/api/getPackage";
export const API_REGISTRATION = "/sales/subscription/api/buySubscription";
export const API_CHECK_EMAIL = "/sales/subscription/api/verifyUser";
export const API_CHECK_DOMAIN = "/sales/subscription/api/checkDomain";
export const API_CITY_LIST = "/sales/subscription/api/cityList";
export const API_DEMO_REQUEST = "/sales/subscription/api/addDemoRequest";
export const API_STATE_LIST = "/sales/subscription/api/stateList";
export const API_ADD_INQUIRY = "/sales/subscription/api/addInquiry";
// export const GOOGLE_MAP_API_KEY = "AIzaSyAdbTCuFhYtC9FlGZXWZKzlzvr_vbSWdZc";
